var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "pageTitle"
  }, [_vm._v("跨案場分析")]), _c('b-overlay', {
    staticClass: "borderColor borderColorBackground mb-3",
    attrs: {
      "show": _vm.showOverlay,
      "variant": "white",
      "opacity": 0.9,
      "z-index": "60"
    },
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function fn() {
        return [_c('div', {
          staticClass: "queryOverlay"
        }, [_c('b-spinner', {
          staticStyle: {
            "width": "2.5rem",
            "height": "2.5rem"
          },
          attrs: {
            "variant": "secondary"
          }
        }), _c('div', {
          staticClass: "queryOverlay-title"
        }, [_vm._v(" 正在查詢 " + _vm._s(_vm.selectedSiteCount) + " 個案場 ")]), _c('div', {
          staticClass: "queryOverlay-elapsed"
        }, [_vm._v(_vm._s(_vm.elapsedText))]), _vm.selectedSiteCount > 40 ? _c('div', {
          staticClass: "queryOverlay-hint"
        }, [_vm._v(" 案場多的時候要跑上百次查詢，請耐心等候 ")]) : _vm._e()], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-wrap m-2"
  }, [_c('button', {
    staticClass: "datepickerButton",
    class: {
      'date-active': _vm.dateTypeActive === 'hour'
    },
    on: {
      "click": function click($event) {
        return _vm.changeDateType('date', 'yyyy-MM-dd', 'hour');
      }
    }
  }, [_vm._v(" 時 ")]), _c('button', {
    staticClass: "datepickerButton",
    class: {
      'date-active': _vm.dateTypeActive === 'date'
    },
    on: {
      "click": function click($event) {
        return _vm.changeDateType('date', 'yyyy-MM-dd', 'date');
      }
    }
  }, [_vm._v(" 日 ")]), _c('button', {
    staticClass: "datepickerButton",
    class: {
      'date-active': _vm.dateTypeActive === 'month'
    },
    on: {
      "click": function click($event) {
        return _vm.changeDateType('month', 'yyyy-MM', 'month');
      }
    }
  }, [_vm._v(" 月 ")]), _c('button', {
    staticClass: "datepickerButton mr-4",
    class: {
      'date-active': _vm.dateTypeActive === 'year'
    },
    on: {
      "click": function click($event) {
        return _vm.changeDateType('year', 'yyyy', 'year');
      }
    }
  }, [_vm._v(" 年 ")]), _c('div', {
    staticClass: "my-2 mr-4"
  }, [_vm._v(" 起始時間 :  "), _c('date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "起始時間",
      "type": _vm.dateType,
      "valueType": "format",
      "disabled-date": _vm.isDateAfterToday
    },
    model: {
      value: _vm.beginDate,
      callback: function callback($$v) {
        _vm.beginDate = $$v;
      },
      expression: "beginDate"
    }
  })], 1), _vm.dateTypeActive !== 'hour' ? _c('div', {
    staticClass: "my-2 mr-4"
  }, [_vm._v(" 結束時間 :  "), _c('date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "結束時間",
      "type": _vm.dateType,
      "valueType": "format",
      "disabled-date": _vm.isDateAfterToday
    },
    model: {
      value: _vm.endDate,
      callback: function callback($$v) {
        _vm.endDate = $$v;
      },
      expression: "endDate"
    }
  })], 1) : _vm._e(), _c('button', {
    staticClass: "datepickerButton",
    on: {
      "click": _vm.multipleDataPush
    }
  }, [_vm._v(" 新增一列 ")]), _c('button', {
    staticClass: "datepickerButton",
    on: {
      "click": _vm.addAllSites
    }
  }, [_vm._v(" 一鍵新增全部案場 ")])]), _c('div', {
    staticClass: "otherTableStyle bg-white tableScroll"
  }, [_c('table', {
    staticClass: "w-100 text-center"
  }, [_c('tr', [_c('th', [_vm._v("序號")]), _c('th', [_vm._v("案場")]), _c('th', [_vm._v("曲線顏色")]), _c('th', [_vm._v("功能")])]), _vm._l(_vm.multipleDataArr, function (i, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_vm._v(_vm._s(idx + 1))]), _c('td', [_c('b-form-select', {
      staticClass: "m-5px w-auto",
      attrs: {
        "size": "sm"
      },
      on: {
        "change": function change($event) {
          i.factory = '';
        }
      },
      model: {
        value: i.county,
        callback: function callback($$v) {
          _vm.$set(i, "county", $$v);
        },
        expression: "i.county"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": "null"
      }
    }, [_vm._v("縣市")]), _vm._l(_vm.countyArr, function (county) {
      return _c('b-form-select-option', {
        key: county,
        attrs: {
          "value": county
        }
      }, [_vm._v(" " + _vm._s(county) + " ")]);
    })], 2), _c('b-form-select', {
      staticClass: "m-5px w-auto",
      attrs: {
        "size": "sm"
      },
      model: {
        value: i.factory,
        callback: function callback($$v) {
          _vm.$set(i, "factory", $$v);
        },
        expression: "i.factory"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("案場")]), _vm._l(_vm.filterFactoryArr(i.county), function (site, siteIdx) {
      return _c('b-form-select-option', {
        key: siteIdx,
        attrs: {
          "value": site.factory
        }
      }, [_vm._v(" " + _vm._s(site.factory) + " ")]);
    })], 2)], 1), _c('td', [_c('b-form-input', {
      staticClass: "mx-auto",
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "color",
        "size": "sm"
      },
      model: {
        value: i.color,
        callback: function callback($$v) {
          _vm.$set(i, "color", $$v);
        },
        expression: "i.color"
      }
    })], 1), _c('td', [_c('button', {
      staticClass: "deleteButton m-5px",
      on: {
        "click": function click($event) {
          return _vm.multipleDataSplice(idx);
        }
      }
    }, [_vm._v(" 刪除 ")])])]);
  })], 2)]), _c('div', {
    staticClass: "bg-white d-flex align-items-center flex-wrap p-2"
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.contextArr,
      "switches": ""
    },
    model: {
      value: _vm.contextDataClass,
      callback: function callback($$v) {
        _vm.contextDataClass = $$v;
      },
      expression: "contextDataClass"
    }
  }), _c('button', {
    staticClass: "confirmButton ml-auto m-2",
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.clickShowChart
    }
  }, [_vm.loadingAction === 'chart' ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.showChart ? '隱藏圖表' : '顯示圖表') + " ")], 1), _c('button', {
    staticClass: "confirmButton m-2",
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.clickDownload
    }
  }, [_vm.loadingAction === 'download' ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" 資料下載 ")], 1)], 1)]), _vm.dataIssues.length ? _c('div', {
    staticClass: "borderColor borderColorBackground mb-3"
  }, [_c('div', {
    staticClass: "bg-white p-3"
  }, [_c('div', {
    staticClass: "mb-2 text-danger"
  }, [_c('b', [_vm._v(_vm._s(_vm.dataIssues.length) + " 個案場沒有資料")]), _vm._v("（圖表與下載都不含這些案場，其餘照常） ")]), _c('ul', {
    staticClass: "mb-0 pl-4",
    staticStyle: {
      "max-height": "160px",
      "overflow-y": "auto"
    }
  }, _vm._l(_vm.dataIssues, function (x) {
    return _c('li', {
      key: x.siteName
    }, [_vm._v(" " + _vm._s(x.siteName) + " — " + _vm._s(x.reason) + " ")]);
  }), 0)])]) : _vm._e(), _vm.showChart ? _c('div', {
    staticClass: "borderColor borderColorBackground mb-4"
  }, [_c('highcharts', {
    ref: "chart",
    staticClass: "bg-white pt-3",
    attrs: {
      "options": _vm.multipleChart
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };